import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Bloquea el acceso a rutas de invitado (login, register, recov-password)
 * cuando el usuario ya está autenticado, redirigiendo a home.
 *
 * Uso:  canActivate: [guestGuard]
 */
export const guestGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.checkAuth()) {
    return router.createUrlTree(['/']);
  }

  return true;
};
